import { render, staticRenderFns } from "./bracket_four.vue?vue&type=template&id=c7127f1a"
import script from "./bracket_four.vue?vue&type=script&lang=js"
export * from "./bracket_four.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports